import {useAppDataStore} from "@/mobx/appDataStore.jsx";
import {useEffect} from "react";
import {useNavigate} from "react-router-dom";

export default function Logout() {
  const appDataStore = useAppDataStore()
  const navigate = useNavigate()
  useEffect(() => {
    appDataStore.logout().then(() => {
      navigate('/')
    })
  }, []);
  return <></>
}